// features/MsalPrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated as useMsalIsAuthenticated } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";

const MsalPrivateRoute = ({ component: Component }) => {
  const { instance } = useMsal();
  const isAuthenticated = useMsalIsAuthenticated();
  const activeAccount = instance.getActiveAccount();

  const isFullyAuthenticated = isAuthenticated && activeAccount;

  return isFullyAuthenticated ? <Component /> : <Navigate to="/provider" replace />;
};

export default MsalPrivateRoute;
